import { Button, Fab, Grid } from "@mui/material";
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useContext } from "react";
import StepperContext from "../Context/StepperContext";

function AddNewCard(props) {
  const { prevStep } = useContext(StepperContext);
  const isActiveFlag = props?.selectedConsentsState?.includes(props?.consentHandle)
		? true
		: false;
  
  // Check for dark theme
  const isDark = props.customDetails?.darkTheme === true;
    const redirect = () => {
    global.fi = global.FIGroups[props.fiType]
    props.history.push(`/home/?number=${global.mobileNumber}&isAddAccount=${true}`, { fiTypes: global.FIGroups[props.fiType] },)
  }
  const handleAddAccount = () => {
    if(!isActiveFlag){
      return
    }
    redirect();
    prevStep();
    return;
  }
  return (
    <Grid
      container
      padding={"1rem"}
      onClick={handleAddAccount}
      sx={{
        alignItems: "center",
        borderRadius: "20px",
        border:  `1.5px dashed ${!isActiveFlag?"lightgray":props.customDetails?.primaryColor}`,
        textAlign: "left",
      }}
    >
      <div>
        <Fab
          disabled={!isActiveFlag}
          component={"button"}
          disableRipple
          color="primary"
          aria-label="add"
          sx={{ minHeight: 0, width: "25px", height: "25px" }}
        >
          +
        </Fab>
        <Button
          disabled={!isActiveFlag}
          variant="text" 
          sx={{...sizeFontCustom.subHeading, marginLeft:'0.5rem', backgroundColor: 'transparent', color:props?.customDetails?.isDark ? '#ffffff' : props.customDetails?.primaryColor}}>
          {props.fiType}
        </Button>
      </div>
    </Grid>
  );
}

export default AddNewCard;
